export enum DisruptionStatus {
    Live = 'Live',
    Cleared = 'Cleared',
    Upcoming = 'Upcoming',
    Planned = 'Planned',
}

export interface Disruption {
    id: number
    status: DisruptionStatus
    reference: string
    location: string
    diversion: string
    sourceLink: string
    start: string
    end: string
    disruptionType: string
    delay: number | null
    author: string
    nmccInformed: boolean | null
    routes: {
        diversion: string | null
        id: number
        route: string
    }[]
    isUserCreated: boolean | null
}
